import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import queryString from 'query-string';
import Breadcrumbs from '~/components/Breadcrumb';
import styles from './index.module.scss';
import WarrantyLookupForm from './components/WarrantyLookupForm';
import WarrantyResultPanel from './components/WarrantyResultPanel';
import { useWarrantyQuery } from '../data/hooks';
import { useWarrantyLookupStore } from '../data/store';

const WarrantyLookup = () => {
  const { t } = useTranslation();
  const currentRoute = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const hasVerifiedCaptcha = useWarrantyLookupStore((s) => s.hasVerifiedCaptcha);

  const [hasSearched, setHasSearched] = useState(false);
  const [searchedSerial, setSearchedSerial] = useState('');

  // Query tự chạy khi searchedSerial đổi và điều kiện enabled thoả — không còn lệnh gọi mệnh lệnh nào.
  const { data, notFound, error, loading, refetch } = useWarrantyQuery(searchedSerial, {
    enabled: hasVerifiedCaptcha && hasSearched,
  });

  const { serial: serialFromUrl } = queryString.parse(location.search);

  // Mở link có sẵn ?serial=... trong khi phiên đã xác thực captcha rồi (F5 lại, hoặc back/forward)
  // → tự tra cứu luôn, không bắt xác thực lại. Chưa xác thực thì chỉ hiện form.
  useEffect(() => {
    if (hasVerifiedCaptcha && serialFromUrl && serialFromUrl !== searchedSerial) {
      setSearchedSerial(serialFromUrl);
      setHasSearched(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasVerifiedCaptcha, serialFromUrl]);

  const handleSearch = (serial) => {
    setSearchedSerial(serial);
    setHasSearched(true);
    history.push({ search: queryString.stringify({ serial }) });
  };

  const handleRetry = () => {
    refetch();
  };

  const breadcrumbNameMap = [{ name: t('header.warrantyLookup'), path: '/warranty-lookup' }];

  // Chưa tra cứu thì aside = null, LookupFormLayout sẽ hiện ảnh minh hoạ như cũ.
  const showResults = hasVerifiedCaptcha && hasSearched;
  const resultPanel = showResults ? (
    <WarrantyResultPanel
      data={data}
      notFound={notFound}
      error={error}
      loading={loading}
      serial={searchedSerial}
      onRetry={handleRetry}
    />
  ) : null;

  return (
    <div className={styles['container']}>
      <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} currentRoute={currentRoute} />
      <div className={styles['content']}>
        <WarrantyLookupForm
          onSubmit={handleSearch}
          loading={loading}
          initialSerial={serialFromUrl}
          aside={resultPanel}
        />
      </div>
    </div>
  );
};

export default WarrantyLookup;
